import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HotspotService {

  constructor(private http: HttpClient) { }

  getHotSpotImage(pPlaceName: string) {
    return this.http.get('https://api.globalbirdwatching.org/se/locid?placename=' + pPlaceName);
  }
}
